import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from "rxjs/index";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GlobalTranslateService {
  yourTranslatedText!:string;
  yourTranslatedObservableText!:string;
  constructor(public translateService: TranslateService) { }
  

  getTranslate(string:any): Observable<any>{
    
    // this.yourTranslatedText = this.translateService.instant(string); 
    // return this.translateService.get(string).subscribe((translatedString) => {
    //     this.yourTranslatedObservableText = translatedString;
    //     return this.yourTranslatedObservableText;
    // });

    return this.translateService.get(string).pipe(
      map((translatedString:any) => {
        this.yourTranslatedObservableText = translatedString;
        console.log('service page',this.yourTranslatedObservableText);
        return translatedString;
      })
    )



    // return this.translateService.get(string).subscribe((translatedString) => {
    //   this.yourTranslatedObservableText = translatedString;
    //   return this.yourTranslatedObservableText;
    // });
  }
}
